export default __webpack_public_path__ + "media/images/logo-stacked-light-e4065991639a7bd2ba34ad857e96239c.png";